import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { withStyles } from "@mui/styles";
import DownloadIcon from "@mui/icons-material/CloudDownload";
import client from "common/admin/client";
import SimpleSnackbar from "common/components/SimpleSnackbar";

const styles = (theme) => ({
  icon: {
    marginRight: theme.spacing(1),
  },
});

class DownloadCSV extends Component {
  state = {
    csvUrl: null,
    error: null,
    empty: null,
  };

  handleClick = async () => {
    const { apiUrl } = this.props;

    try {
      const { csvUrl, empty } = await client.get(apiUrl);
      this.setState({ csvUrl, empty });
    } catch (error) {
      this.setState({ error });
    }
  };

  render() {
    const { classes, title } = this.props;
    const { csvUrl, empty, error } = this.state;

    if (csvUrl) {
      return (
        <a href={csvUrl}>
          <Button>Download CSV</Button>
        </a>
      );
    }

    return (
      <Fragment>
        <Button variant="contained" onClick={this.handleClick}>
          <DownloadIcon className={classes.icon} />
          {title}
        </Button>

        {empty ? <SimpleSnackbar message={"No results found"} /> : null}

        {error ? (
          <SimpleSnackbar message={"Failed to generate CSV data"} />
        ) : null}
      </Fragment>
    );
  }
}

DownloadCSV.propTypes = {
  title: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  apiUrl: PropTypes.string.isRequired,
};

export default withStyles(styles)(DownloadCSV);
